(async () => {
    try {
        const rxjs = await import('https://unpkg.com/@esm-bundle/rxjs/esm/es2015/rxjs.min.js')
        const subscribe = window.subscribe
        const dataLayer = window.dataLayer || {}
        const _learnq = window._learnq || []
        const getCart = window.getCart || (() => { })

        const dataLayerPush = (eventName, data) => {
            // to do: handle klaviyo here
        }

        const klaviyoPush = (eventName, data) => {
            // to do: handle klaviyo here
        }

        const cartErrorComposition = {
            create: (event) => {
                const {source, error, context } = event || {}
                if (source === 'auto-add') {
                    dataLayer.push({
                        event: 'autoAddError',
                        errorMessage: error.message,
                        context
                    })
                }
            },
            delete: (event) => {
                // to do: handle cart delete errors here
            },
            update: (event) => {
                // to do: handle cart update errors here
            }
        }

        const cartActionComposition = {
            create: (event) => {
                dataLayerPush('addToCart', event)
                klaviyoPush('addToCart', event)
            },
            delete: (event) => {
                // to do: trigger cart detele analytics here
            },
            update: (event) => {
                // to do: trigger cart update analytics here
            }
        }

        const subscriptionComposition = {
            'cart-update': (event) => {
                const { action } = event || {}
                if (cartActionComposition[action]) {
                    cartActionComposition[action](event)
                }
            },
            'cart-error': (event) => {
                const { action } = event || {}
                if (cartErrorComposition[action]) {
                    cartErrorComposition[action](event)
                }
            }
        }

        function createEventStream(eventName) {
            return new rxjs.Observable(subscriber => {
                subscribe(eventName, (data) => subscriber.next({ eventName, data }));
                return () => { };
            });
        }

        const cartEventsStream = createEventStream('cart-error')
            .pipe(
                rxjs.bufferTime(1000),
                rxjs.filter(batch => batch.length > 0),
                rxjs.distinctUntilChanged((prev, curr) => {
                    return JSON.stringify(prev) === JSON.stringify(curr)
                })
            )

        cartEventsStream.subscribe({
            next: batch => {
                batch.forEach(event => {
                    const { eventName, data } = event;
                    if (subscriptionComposition[eventName]) {
                        subscriptionComposition[eventName](data);
                    }
                });
            },
            error: err => console.error(err, 'background: #222 color: red'),
            complete: () => console.log('Stream completed')
        });

    } catch (error) {
        console.error(error)
    }
})()